module.exports = __webpack_public_path__ + "static/media/lg.3aaefcd1.png";